import { Component, computed, inject, input, resource } from '@angular/core';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { RolleDetailService } from '../rolle-detail/rolle-detail.service';
import { RettighederService } from '../rettigheder.service';
import { RolleRettighed } from './rolle-rettighed.model';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { RolleRettighedApi } from '@features/roller/rolle-rettigheder/rolle-rettigheder.api';

@Component({
  selector: 'app-rolle-rettigheder',
  imports: [CheckboxModule, FormsModule, ScrollPanelModule],
  templateUrl: './rolle-rettigheder.component.html',
  styleUrl: './rolle-rettigheder.component.css',
})
export class RolleRettighederComponent {
  rolleRettighedApi = inject(RolleRettighedApi);
  rolleId = input.required<number>();
  rolleDetailService = inject(RolleDetailService);
  rettighedService = inject(RettighederService);

  data = resource({
    params: () => this.rolleId(),
    loader: async ({ params, abortSignal }) => {
      return await this.rolleRettighedApi.getList(
        {
          filter: JSON.stringify({
            rolleId: params,
          }),
        },
        abortSignal
      );
    },
  });

  rettighedData = computed(() => {
    const _rettighedData: RettighedData[] = [];
    const alleRettigheder = this.rettighedService.data();
    const rolleRettigheder = this.data.value()?.data || [];

    alleRettigheder.forEach(r => {
      const found = rolleRettigheder.filter(rolleRettighed => {
        return rolleRettighed.rettighed === r.name;
      });
      let rr: RolleRettighed | undefined = undefined;
      if (found.length > 0) {
        rr = found[0];
      }
      _rettighedData.push({ ...r, rolleRettighed: rr, checked: !!rr });
    });
    return _rettighedData;
  });

  grant(r: RettighedData) {
    if (r.checked) {
      if (this.rolleDetailService.changes[r.name]?.action === 'add') {
        delete this.rolleDetailService.changes[r.name];
      } else {
        this.rolleDetailService.changes[r.name] = {
          action: 'remove',
          id: r.rolleRettighed?.id,
        };
      }
    } else {
      if (this.rolleDetailService.changes[r.name]?.action === 'remove') {
        delete this.rolleDetailService.changes[r.name];
      } else {
        this.rolleDetailService.changes[r.name] = {
          action: 'add',
          rettighed: r.name,
        };
      }
    }
  }
}

interface RettighedData {
  name: string;
  description: string;
  checked: boolean;
  rolleRettighed?: RolleRettighed;
}
